import React from 'react'
import { Button, Table, Image , Header} from 'semantic-ui-react'
import { connect } from 'react-redux'
import { moderateUser } from '../reducers/user/actions';
import { getBannedPlayers } from '../reducers/bannedplayers/index';
import defaultavatar from '../assets/avatargenerico.png' 


class BannedList extends React.PureComponent {
   

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount(this.props.socket)
    }

    handleBan = (e, {user_id}) => {
        const {moderateUser, socket} = this.props
        e.preventDefault();
        moderateUser(socket,{user_id});
    }


    render(){
        const {banned_users} = this.props
        const ids = Object.keys(banned_users);
        return(
            <Table>
            <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Utenti bannati</Table.HeaderCell>
                <Table.HeaderCell>Sbanna</Table.HeaderCell>
            </Table.Row>
            </Table.Header>
            <Table.Body>
            
            {(ids && ids.length>0)?ids.map(id => (
                <Table.Row>
                <Table.Cell>
                <Header as='h4' image>
                    <Image src={(banned_users[id].exp_user? banned_users[id].exp_user.avatar: defaultavatar) } size = 'mini' circular/>
                    <Header.Content>
                    {banned_users[id].username}
                    <Header.Subheader>NumOfBan {(banned_users[id].exp_user? banned_users[id].exp_user.ban_number: '?') }</Header.Subheader>
                    </Header.Content>
                </Header>
                </Table.Cell>
                <Table.Cell>
                <Button color='green' content='Unban this user' user_id = {id} onClick = {this.handleBan}/>
                </Table.Cell>
                </Table.Row>
              )
            ):
            <Table.Row>
                <Table.Cell colSpan = {2}>
                Non ci sono utenti bannati!
                </Table.Cell>
            </Table.Row>    
            }
            </Table.Body>
            </Table>
        )
    }
}

const mapStateToProps = (state) => ({
    banned_users : state.bannedplayers,
    socket : state.socket
})

const mapDispatchToProps = (dispatch) => ({
    moderateUser: (socket, {user_id}) =>dispatch(moderateUser(socket,{user_id})),
    onMount: (socket) => dispatch(getBannedPlayers(socket))  
})


export default connect(
    mapStateToProps,
    mapDispatchToProps 
)(BannedList)



// WEBPACK FOOTER //
// ./src/components/BannedList.js